import React, { Component } from 'react';

class SkinConcerns extends Component {
	render() {
		return (
			<section className="assessment bg name__age skin__concerns">
				<div className="container-fluid">
					<h1 className="assessment__heading">What are your top skin concerns?</h1>
					<span className="small__tital">Select upto 2</span>
					<div className="name__age--badges">
						<span>Acne</span>
						<span>Redness</span>
						<span>Pigmentation</span>
						<span>Wrinkles / Age Spots</span>
						<span>Blackheads / Whiteheads</span>
						<span>Others, Enter here</span>
					</div>
				</div>
			</section>
		);
	}
}


export default SkinConcerns;